import React from 'react'
import FaCircle from 'react-icons/lib/fa/circle';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getPercentileInfo } from '../../util/cutscores';

export default function ClassProgressStudentName(props) {
  const {studentData} = props;
  const {BOY={}, MOY={}, EOY={}, name, EM={}} = studentData;

  const {t} = useTranslation("class_progress_report")
  const selectedStatePercentileCuts = useSelector(state => state.reports.teacher.selectedStatePercentileCuts);

  let latestPR = null;
  if (BOY.PR || BOY.PR === 0) latestPR = BOY.PR;
  if (MOY.PR || MOY.PR === 0) latestPR = MOY.PR;
  if (EOY.PR || EOY.PR === 0) latestPR = EOY.PR;
  if (EM.PR || EM.PR === 0) latestPR = EM.PR;

  // determine recommendation label
  let recommendationColor;
  let instructionalRecommendation;

  const recommendationStyle = {};
  if (latestPR) {
    const percentileInfo = getPercentileInfo(latestPR, selectedStatePercentileCuts);
    recommendationColor = percentileInfo.color;
    instructionalRecommendation = percentileInfo.label;
    recommendationStyle.color = percentileInfo.color;
  }

  return (
    <div className="classProgressRowIndex">
      <div className="classProgressName">{name}</div>
      {!!recommendationColor && <div className="classProgressRecommendation" style={recommendationStyle}>
        <div className="recommendationIcon"><FaCircle /></div>
        <div>{t(instructionalRecommendation)}</div>
      </div>}
    </div>
  )
}
